// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/icons/icomoon.eot?836x7l", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/icons/icomoon.ttf?836x7l", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/icons/icomoon.woff?836x7l", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/icons/icomoon.svg?836x7l", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#icomoon" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "icomoon";
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

[class^="icon-"],
[class*=" icon-"] {
  font-family: "icomoon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
}
.icon-chart::before {
  content: "\\e91c";
  color: #a7b6c2;
}
.icon-database::before {
  content: "\\e91d";
  color: #a7b6c2;
}
.icon-doughnut-chart::before {
  content: "\\e91e";
  color: #a7b6c2;
}
.icon-grouped-bar-chart1::before {
  content: "\\e92c";
  color: #a7b6c2;
}
.icon-heat-grid::before {
  content: "\\e92d";
  color: #a7b6c2;
}
.icon-heatmap::before {
  content: "\\e92e";
  color: #a7b6c2;
}
.icon-horizontal-bar-chart1::before {
  content: "\\e92f";
  color: #a7b6c2;
}
.icon-pie-chart::before {
  content: "\\e930";
  color: #a7b6c2;
}
.icon-series-filtered::before {
  content: "\\e931";
  color: #a7b6c2;
}
.icon-series-search1::before {
  content: "\\e932";
  color: #a7b6c2;
}
.icon-stacked-chart1::before {
  content: "\\e933";
  color: #a7b6c2;
}
.icon-timeline-bar-chart::before {
  content: "\\e934";
  color: #a7b6c2;
}
.icon-calendar1::before {
  content: "\\e901";
  color: #a7b6c2;
}
.icon-caret-down::before {
  content: "\\e902";
  color: #a7b6c2;
}
.icon-caret-left::before {
  content: "\\e903";
  color: #a7b6c2;
}
.icon-caret-right::before {
  content: "\\e904";
  color: #a7b6c2;
}
.icon-caret-up::before {
  content: "\\e905";
  color: #a7b6c2;
}
.icon-chevron-down::before {
  content: "\\e906";
  color: #a7b6c2;
}
.icon-chevron-left::before {
  content: "\\e907";
  color: #a7b6c2;
}
.icon-chevron-right::before {
  content: "\\e908";
  color: #a7b6c2;
}
.icon-chevron-up::before {
  content: "\\e909";
  color: #a7b6c2;
}
.icon-circle-arrow-down::before {
  content: "\\e90a";
  color: #a7b6c2;
}
.icon-circle-arrow-left::before {
  content: "\\e90b";
  color: #a7b6c2;
}
.icon-circle-arrow-right::before {
  content: "\\e90c";
  color: #a7b6c2;
}
.icon-circle-arrow-up::before {
  content: "\\e90d";
  color: #a7b6c2;
}
.icon-double-chevron-down::before {
  content: "\\e927";
  color: #a7b6c2;
}
.icon-double-chevron-left::before {
  content: "\\e928";
  color: #a7b6c2;
}
.icon-double-chevron-right::before {
  content: "\\e929";
  color: #a7b6c2;
}
.icon-double-chevron-up::before {
  content: "\\e92a";
  color: #a7b6c2;
}
.icon-envelope::before {
  content: "\\e92b";
  color: #a7b6c2;
}
.icon-helper-management::before {
  content: "\\e935";
  color: #a7b6c2;
}
.icon-info-sign::before {
  content: "\\e90e";
  color: #a7b6c2;
}
.icon-layers::before {
  content: "\\e90f";
  color: #a7b6c2;
}
.icon-map-marker::before {
  content: "\\e910";
  color: #a7b6c2;
}
.icon-notifications::before {
  content: "\\e911";
  color: #a7b6c2;
}
.icon-people::before {
  content: "\\e912";
  color: #a7b6c2;
}
.icon-person::before {
  content: "\\e913";
  color: #a7b6c2;
}
.icon-random::before {
  content: "\\e93a";
  color: #a7b6c2;
}
.icon-star-empty::before {
  content: "\\e914";
  color: #a7b6c2;
}
.icon-star::before {
  content: "\\e915";
  color: #a7b6c2;
}
.icon-swap-horizontal::before {
  content: "\\e93b";
  color: #a7b6c2;
}
.icon-timeline-events::before {
  content: "\\e916";
  color: #a7b6c2;
}
.icon-key-escape::before {
  content: "\\e917";
  color: #a7b6c2;
}
.icon-media::before {
  content: "\\e918";
  color: #a7b6c2;
}
.icon-power::before {
  content: "\\e936";
  color: #a7b6c2;
}
.icon-edit::before {
  content: "\\e93c";
  color: #a7b6c2;
}
.icon-exchange::before {
  content: "\\e93d";
  color: #a7b6c2;
}
.icon-export::before {
  content: "\\e93e";
  color: #a7b6c2;
}
.icon-geosearch::before {
  content: "\\e93f";
  color: #a7b6c2;
}
.icon-help::before {
  content: "\\e919";
  color: #a7b6c2;
}
.icon-search-template::before {
  content: "\\e940";
  color: #a7b6c2;
}
.icon-search-text::before {
  content: "\\e941";
  color: #a7b6c2;
}
.icon-search::before {
  content: "\\e942";
  color: #a7b6c2;
}
.icon-signal-search::before {
  content: "\\e943";
  color: #a7b6c2;
}
.icon-zoom-in::before {
  content: "\\e91a";
  color: #a7b6c2;
}
.icon-zoom-out::before {
  content: "\\e91b";
  color: #a7b6c2;
}
.icon-grouped-bar-chart::before {
  content: "\\e91f";
  color: #a7b6c2;
}
.icon-horizontal-bar-chart-asc::before {
  content: "\\e920";
  color: #a7b6c2;
}
.icon-horizontal-bar-chart-desc::before {
  content: "\\e921";
  color: #a7b6c2;
}
.icon-horizontal-bar-chart::before {
  content: "\\e922";
  color: #a7b6c2;
}
.icon-series-search::before {
  content: "\\e923";
  color: #a7b6c2;
}
.icon-stacked-chart::before {
  content: "\\e924";
  color: #a7b6c2;
}
.icon-timeline-line-chart::before {
  content: "\\e925";
  color: #a7b6c2;
}
.icon-calendar::before {
  content: "\\e926";
  color: #a7b6c2;
}
.icon-cog::before {
  content: "\\e937";
  color: #a7b6c2;
}
.icon-control::before {
  content: "\\e938";
  color: #a7b6c2;
}
.icon-data-lineage::before {
  content: "\\e939";
  color: #a7b6c2;
}
.icon-home::before {
  content: "\\e900";
  color: #f8f8f8;
}
`, "",{"version":3,"sources":["webpack://./src/styles/_icons.scss"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB;;;;yDAIiE;EACjE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["@font-face {\n  font-family: \"icomoon\";\n  src:\n    url(\"../assets/icons/icomoon.eot?836x7l\"),\n    url(\"../assets/icons/icomoon.ttf?836x7l\") format(\"truetype\"),\n    url(\"../assets/icons/icomoon.woff?836x7l\") format(\"woff\"),\n    url(\"../assets/icons/icomoon.svg?836x7l#icomoon\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-\"],\n[class*=\" icon-\"] {\n  font-family: \"icomoon\" !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n}\n.icon-chart::before {\n  content: \"\\e91c\";\n  color: #a7b6c2;\n}\n.icon-database::before {\n  content: \"\\e91d\";\n  color: #a7b6c2;\n}\n.icon-doughnut-chart::before {\n  content: \"\\e91e\";\n  color: #a7b6c2;\n}\n.icon-grouped-bar-chart1::before {\n  content: \"\\e92c\";\n  color: #a7b6c2;\n}\n.icon-heat-grid::before {\n  content: \"\\e92d\";\n  color: #a7b6c2;\n}\n.icon-heatmap::before {\n  content: \"\\e92e\";\n  color: #a7b6c2;\n}\n.icon-horizontal-bar-chart1::before {\n  content: \"\\e92f\";\n  color: #a7b6c2;\n}\n.icon-pie-chart::before {\n  content: \"\\e930\";\n  color: #a7b6c2;\n}\n.icon-series-filtered::before {\n  content: \"\\e931\";\n  color: #a7b6c2;\n}\n.icon-series-search1::before {\n  content: \"\\e932\";\n  color: #a7b6c2;\n}\n.icon-stacked-chart1::before {\n  content: \"\\e933\";\n  color: #a7b6c2;\n}\n.icon-timeline-bar-chart::before {\n  content: \"\\e934\";\n  color: #a7b6c2;\n}\n.icon-calendar1::before {\n  content: \"\\e901\";\n  color: #a7b6c2;\n}\n.icon-caret-down::before {\n  content: \"\\e902\";\n  color: #a7b6c2;\n}\n.icon-caret-left::before {\n  content: \"\\e903\";\n  color: #a7b6c2;\n}\n.icon-caret-right::before {\n  content: \"\\e904\";\n  color: #a7b6c2;\n}\n.icon-caret-up::before {\n  content: \"\\e905\";\n  color: #a7b6c2;\n}\n.icon-chevron-down::before {\n  content: \"\\e906\";\n  color: #a7b6c2;\n}\n.icon-chevron-left::before {\n  content: \"\\e907\";\n  color: #a7b6c2;\n}\n.icon-chevron-right::before {\n  content: \"\\e908\";\n  color: #a7b6c2;\n}\n.icon-chevron-up::before {\n  content: \"\\e909\";\n  color: #a7b6c2;\n}\n.icon-circle-arrow-down::before {\n  content: \"\\e90a\";\n  color: #a7b6c2;\n}\n.icon-circle-arrow-left::before {\n  content: \"\\e90b\";\n  color: #a7b6c2;\n}\n.icon-circle-arrow-right::before {\n  content: \"\\e90c\";\n  color: #a7b6c2;\n}\n.icon-circle-arrow-up::before {\n  content: \"\\e90d\";\n  color: #a7b6c2;\n}\n.icon-double-chevron-down::before {\n  content: \"\\e927\";\n  color: #a7b6c2;\n}\n.icon-double-chevron-left::before {\n  content: \"\\e928\";\n  color: #a7b6c2;\n}\n.icon-double-chevron-right::before {\n  content: \"\\e929\";\n  color: #a7b6c2;\n}\n.icon-double-chevron-up::before {\n  content: \"\\e92a\";\n  color: #a7b6c2;\n}\n.icon-envelope::before {\n  content: \"\\e92b\";\n  color: #a7b6c2;\n}\n.icon-helper-management::before {\n  content: \"\\e935\";\n  color: #a7b6c2;\n}\n.icon-info-sign::before {\n  content: \"\\e90e\";\n  color: #a7b6c2;\n}\n.icon-layers::before {\n  content: \"\\e90f\";\n  color: #a7b6c2;\n}\n.icon-map-marker::before {\n  content: \"\\e910\";\n  color: #a7b6c2;\n}\n.icon-notifications::before {\n  content: \"\\e911\";\n  color: #a7b6c2;\n}\n.icon-people::before {\n  content: \"\\e912\";\n  color: #a7b6c2;\n}\n.icon-person::before {\n  content: \"\\e913\";\n  color: #a7b6c2;\n}\n.icon-random::before {\n  content: \"\\e93a\";\n  color: #a7b6c2;\n}\n.icon-star-empty::before {\n  content: \"\\e914\";\n  color: #a7b6c2;\n}\n.icon-star::before {\n  content: \"\\e915\";\n  color: #a7b6c2;\n}\n.icon-swap-horizontal::before {\n  content: \"\\e93b\";\n  color: #a7b6c2;\n}\n.icon-timeline-events::before {\n  content: \"\\e916\";\n  color: #a7b6c2;\n}\n.icon-key-escape::before {\n  content: \"\\e917\";\n  color: #a7b6c2;\n}\n.icon-media::before {\n  content: \"\\e918\";\n  color: #a7b6c2;\n}\n.icon-power::before {\n  content: \"\\e936\";\n  color: #a7b6c2;\n}\n.icon-edit::before {\n  content: \"\\e93c\";\n  color: #a7b6c2;\n}\n.icon-exchange::before {\n  content: \"\\e93d\";\n  color: #a7b6c2;\n}\n.icon-export::before {\n  content: \"\\e93e\";\n  color: #a7b6c2;\n}\n.icon-geosearch::before {\n  content: \"\\e93f\";\n  color: #a7b6c2;\n}\n.icon-help::before {\n  content: \"\\e919\";\n  color: #a7b6c2;\n}\n.icon-search-template::before {\n  content: \"\\e940\";\n  color: #a7b6c2;\n}\n.icon-search-text::before {\n  content: \"\\e941\";\n  color: #a7b6c2;\n}\n.icon-search::before {\n  content: \"\\e942\";\n  color: #a7b6c2;\n}\n.icon-signal-search::before {\n  content: \"\\e943\";\n  color: #a7b6c2;\n}\n.icon-zoom-in::before {\n  content: \"\\e91a\";\n  color: #a7b6c2;\n}\n.icon-zoom-out::before {\n  content: \"\\e91b\";\n  color: #a7b6c2;\n}\n.icon-grouped-bar-chart::before {\n  content: \"\\e91f\";\n  color: #a7b6c2;\n}\n.icon-horizontal-bar-chart-asc::before {\n  content: \"\\e920\";\n  color: #a7b6c2;\n}\n.icon-horizontal-bar-chart-desc::before {\n  content: \"\\e921\";\n  color: #a7b6c2;\n}\n.icon-horizontal-bar-chart::before {\n  content: \"\\e922\";\n  color: #a7b6c2;\n}\n.icon-series-search::before {\n  content: \"\\e923\";\n  color: #a7b6c2;\n}\n.icon-stacked-chart::before {\n  content: \"\\e924\";\n  color: #a7b6c2;\n}\n.icon-timeline-line-chart::before {\n  content: \"\\e925\";\n  color: #a7b6c2;\n}\n.icon-calendar::before {\n  content: \"\\e926\";\n  color: #a7b6c2;\n}\n.icon-cog::before {\n  content: \"\\e937\";\n  color: #a7b6c2;\n}\n.icon-control::before {\n  content: \"\\e938\";\n  color: #a7b6c2;\n}\n.icon-data-lineage::before {\n  content: \"\\e939\";\n  color: #a7b6c2;\n}\n.icon-home::before {\n  content: \"\\e900\";\n  color: #f8f8f8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
